export default [
    {
        path: 'datasets',
        name: 'list-datasets',
        component: () => import('pages/convey/datasets/list'),
    },
    {
        path: 'datasets/new',
        name: 'create-dataset',
        component: () => import('pages/convey/datasets/create'),
    },
    {
        path: 'datasets/new/data_source_preview',
        name: 'dataset-source-preview',
        component: () => import('pages/convey/datasets/create/data-source-preview'),
    },
    {
        path: 'dataset/:datasetId',
        name: 'view-dataset',
        component: () => import('pages/convey/datasets/view'),
    },
    {
        path: 'analysis/new',
        name: 'create-analysis-job',
        component: () => import('pages/external_api/annotation_jobs/create/index.vue'),
    },
    {
        path: 'analysis/:jobId',
        name: 'edit-analysis-job',
        component: () => import('pages/external_api/annotation_jobs/create/index.vue'),
    },
];
